<template>
  <div class="skeleton-card-dashboard" v-if="loading">
    <v-skeleton-loader class="skeleton-card-loader" type="card"></v-skeleton-loader>
  </div>
  <v-card v-else :class="customClass" class="custom-card-dashboard">
    <v-card-text>
      <v-row>
        <v-col cols="8">
          <div>
            <v-label :class="customClassText" class="title-card-dashboard mb-0">{{ title }}</v-label>
          </div>
          <div>
            <v-label :class="customClassText" class="subtitle-card-dashboard">{{ subtitle }}</v-label>
          </div>
          <div>
            <v-label :class="customClassText" class="subtext-card-dashboard">{{ active }}/{{ total }}</v-label>
          </div>
        </v-col>
        <v-col cols="4" class="d-flex justify-content-end align-items-end">
          <div :class="customClassIcon" v-if="icon">
            <img :src="getIconPath(icon)" style="width: 32px; height: 32px" />
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: "",
    },
    customClass: {
      type: String,
      default: "",
    },
    customClassText: {
      type: String,
      default: "",
    },
    customClassIcon: {
      type: String,
      default: "",
    },
    active: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    getIconPath(iconPath) {
      try {
        return require(`@/assets/images/` + iconPath);
      } catch (error) {
        console.warn("Icon not found:", iconPath);
        return "";
      }
    },
  },
};
</script>
